import request from 'services/request';

export async function InventoriesMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/BaseInformationAgreement/MassLoadInventoryExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
